module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContainer"
  }, [_c('div', {
    staticClass: "summaryContainer"
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('h1', {
    staticClass: "summary-header"
  }, [_c('div', {
    staticClass: "summary-symbol"
  }, [_vm._v(_vm._s(_vm.symbol) + "\r\n          "), _c('i', {
    staticClass: "i summary-star",
    domProps: {
      "textContent": _vm._s(_vm.starClass)
    },
    on: {
      "click": _vm.toggleStar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "summary-toolbar"
  }, [_c('router-link', {
    staticClass: "summary-edit",
    attrs: {
      "to": '/stock/' + _vm.$route.params.symbol + '/edit'
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("edit")]), _vm._v("\r\n            Edit\r\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "summary-name",
    domProps: {
      "textContent": _vm._s(_vm.stock.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-industry"
  }, [_vm._v(_vm._s(_vm.stock.industry) + "\r\n        "), (_vm.stock.sector) ? _c('span', {
    staticClass: "summary-sector"
  }, [_vm._v("\r\n          > " + _vm._s(_vm.stock.sector) + "\r\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('relevant-link', {
    attrs: {
      "title": "SET",
      "url": 'http://www.set.or.th/set/companyprofile.do?symbol=' + _vm.symbol + '&language=th&country=TH'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/set.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Thai VI",
      "url": 'http://board.thaivi.org/jump.php?stock=' + _vm.symbol + '&unread=0'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tvi.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Jitta",
      "url": 'https://www.jitta.com/stock/bkk:' + _vm.symbol
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jitta.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Panphol",
      "url": 'http://www.panphol.com/data/page/stock_dividend/' + _vm.symbol
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pan.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Siam Chart",
      "url": 'http://siamchart.com/stock-chart/' + _vm.symbol
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sc.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Opp Day",
      "url": 'http://www.dcs-digital.com/setweb/index.php?company=' + _vm.symbol + '&mai=&qt=all'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/opp.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "WSJ (Cash Flow)",
      "url": 'http://quotes.wsj.com/TH/' + _vm.symbol + '/financials/annual/cash-flow'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/wsj.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Morningstar",
      "url": 'http://www.morningstar.com/stocks/XBKK/' + _vm.symbol + '/quote.html'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ms.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "IAA Consensus",
      "url": 'http://www.settrade.com/AnalystConsensus/C04_10_stock_saa_p1.jsp?txtSymbol=' + _vm.symbol
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/iaa.png")
    }
  })]), _vm._v(" "), _c('relevant-link', {
    attrs: {
      "title": "Bloomberg",
      "url": 'https://www.bloomberg.com/quote/' + _vm.symbol + ':TB'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bb.png")
    }
  })])], 1)]), _vm._v(" "), _c('tabs', [_c('tab', {
    attrs: {
      "name": "Notes",
      "selected": ""
    }
  }, [_c('div', {
    staticClass: "stock-text markdown-text",
    domProps: {
      "innerHTML": _vm._s(this.note)
    }
  })]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Financial"
    }
  }, [_c('div', {
    staticClass: "stock-text markdown-text",
    domProps: {
      "innerHTML": _vm._s(this.financial)
    }
  })]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "SWOT"
    }
  }, [_c('div', {
    staticClass: "stock-label"
  }, [_vm._v("Strengths")]), _vm._v(" "), _c('ul', _vm._l((_vm.swot.s), function(point) {
    return _c('li', [_vm._v(_vm._s(point))])
  })), _vm._v(" "), _c('div', {
    staticClass: "stock-label"
  }, [_vm._v("Weaknesses")]), _vm._v(" "), _c('ul', _vm._l((_vm.swot.w), function(point) {
    return _c('li', [_vm._v(_vm._s(point))])
  })), _vm._v(" "), _c('div', {
    staticClass: "stock-label"
  }, [_vm._v("Opportunities")]), _vm._v(" "), _c('ul', _vm._l((_vm.swot.o), function(point) {
    return _c('li', [_vm._v(_vm._s(point))])
  })), _vm._v(" "), _c('div', {
    staticClass: "stock-label"
  }, [_vm._v("Threats")]), _vm._v(" "), _c('ul', _vm._l((_vm.swot.t), function(point) {
    return _c('li', [_vm._v(_vm._s(point))])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-694286c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stockview.vue
// module id = 71
// module chunks = 0